// extracted by mini-css-extract-plugin
export default {"partnerWrapper":"styles_partnerWrapper__hCVwQ","buttonBack":"styles_buttonBack__cUHnv","text":"styles_text__Lfb9p","nextButton":"styles_nextButton__5Oye3"};